export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";

export const SCREEN_BREAKPOINT = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};

export const NUMBER_LETTER = [
  "〇",
  "壹",
  "貮",
  "叁",
  "肆",
  "伍",
  "陆",
  "柒",
  "捌",
  "玖",
];
